import { EMPTY_OBJECT } from '../../../../constants/common'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../../utils/massActions'
import { RATING_TYPE_LIST, RATING_TYPE_OVERALL } from '../../../Rating'
import { RATING_CARD_ACTION_EDIT } from '../RequestProfileTabRating.constants'

export function getRatingCardRows(item) {
  const valueByType = {
    [RATING_TYPE_OVERALL]: item?.rating?.value,
  }

  item?.extra_ratings?.forEach(({ rating_type_id: type, value }) => {
    valueByType[type] = value
  })

  return RATING_TYPE_LIST.map(type => ({
    type,
    value: valueByType[type] || 0,
  }))
}

export function getRatingCardActions({ permissions = EMPTY_OBJECT, t }) {
  return parseActionsOnValidDivider(
    filterPermittedActionsWithDividers([
      {
        label: t('RequestProfileTabRating.EditActionOptionKey'),
        permission: permissions.can_edit || permissions.can_edit_rating,
        value: RATING_CARD_ACTION_EDIT,
      },
    ])
  )
}

export function isRatingCardEditAction(action) {
  return action === RATING_CARD_ACTION_EDIT
}
